/**
 * Builds the GET URL for the pre-commande PDF report.
 * When `contexteApprobation` is true, the backend keeps only En approbation
 * and En traitement pre-commandes (SIH-266).
 */
export function construireUrlRapportPreCommande(
    templateUrl: string,
    emplacementId: number,
    contexteApprobation = false
): string {
    const url = templateUrl.replace('{id}', emplacementId.toString());
    return contexteApprobation ? `${url}?contexteApprobation=true` : url;
}
